module.exports = __webpack_public_path__ + "static/media/class.42f180d7.svg";